export default "__VITE_ASSET__jTKufowH__"